import { useTranslation } from "react-i18next";
import React, { useMemo } from "react";
import { GetBuildingUserNotAssigned } from "../../../reduxToolkit/Building/BuildingApi";
import { SEARCH_MODEL } from "../../../components/table/Model/TableModel";
import { TABLES } from "../../../Apis/Tables";
import { IconChipMultiplePerson } from "../../../components/buttons/IconButtons";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Add tab configuration of a building resource section, mirrors the shift access
 * AddShiftResourceApp custom access (employees) branch: the catalog is the
 * building not-assigned endpoint, so it excludes the users already assigned to
 * the building, and the selection is kept client side.
 *
 * @param {Object} props
 * @param {string} props.resource - One of BUILDING_RESOURCE.
 * @param {number|string|null|undefined} props.id - Building id; absent in create.
 * @returns {{t: Function, dynamicConfig: Object}}
 */
export const AddBuildingResourceApp = ({ resource, id }) => {
    const { t } = useTranslation();

    const dynamicConfig = useMemo(() => ({
        api: GetBuildingUserNotAssigned,
        keyId: 'userId',
        labelRowsPerPage: 'employees_per_page',
        tableNotInformationLegend: 'no_results_found',
        titleContainer: 'available_employees',
        selectTitleContainer: 'selected_employees',
        searchLabel: 'search_by_name_email_or_phone',
        selectedSectionIconTitle: <IconChipMultiplePerson height={18} width={18} className={"mr-8px mb-1 icon-color-general-950"} />,
        buildBody: ({ page, rowsPerPage, searchElement }) => SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            key: searchElement,
            model: TABLES.BUILDING_USER,
            modelId: id ?? null
        }),
    }), [resource, id]);

    return { t, dynamicConfig };
}
